import { NOTIFICATION_DEFAULT_WIDTH } from '../../constants'

export const getBaseParams = ({ widthMobile }) => {
  return {
    indent: {
      y: '1.500rem',
    },
    axis: 'y',
    direction: 'backward',
    // используем widthMobile, если дефолтный размер не умещается
    width:
      widthMobile < NOTIFICATION_DEFAULT_WIDTH
        ? widthMobile
        : NOTIFICATION_DEFAULT_WIDTH,
  }
}
